// src/App.js
import React from "react";
import WebViewComponent from "./components/WebViewComponent";

const App = () => {
  return <WebViewComponent />;
};

export default App;
